/* eslint-disable no-console */

import variationHelper from './variationHelper';
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var quantityHelper = require('../quantitySelectorHelper');
var verifyOOSIfRequired = require('antavo_custom/cart/verifyOOS').verifyOOSIfRequired;
var constants = require('../constants'); // eslint-disable-line
var utils = require('../utils');

var splitText = window.PVH.customer && window.PVH.customer.customerGroups ? window.PVH.customer.customerGroups.split(',') : [];
var isCustomerAuthenticated = splitText.includes('authenticatedusers');
var isProductMembersOnly = $('.ismembersonly').data('ismembersonly');
var $loginPromptButton = $('.login-acc-container.member-signin-link');
var $addToCartButton = $('.add-to-cart-container button.add-to-cart');
var $stickyAddToCartButton = $('button.sticky-add-to-cart');
var $applePayButton = $('.dw-apple-pay-button');
var $applePayContainer = $('.applepay-container');
const isOOBO = $('#isOOBO').val() === 'true';

if (isProductMembersOnly && !isCustomerAuthenticated) {
    $loginPromptButton.removeClass('d-none');
    $addToCartButton.addClass('d-none');
    $stickyAddToCartButton.addClass('d-none');
    if ($applePayContainer) {
        $applePayContainer.addClass('d-none');
    }
} else if (isProductMembersOnly && isCustomerAuthenticated) {
    $loginPromptButton.addClass('d-none');
    $addToCartButton.removeClass('d-none');
    $stickyAddToCartButton.removeClass('d-none');
    if ($applePayContainer) {
        $applePayContainer.removeClass('d-none');
    }
} else {
    $loginPromptButton.addClass('d-none');
    $addToCartButton.removeClass('d-none');
    $stickyAddToCartButton.removeClass('d-none');
    if ($applePayContainer) {
        $applePayContainer.removeClass('d-none');
    }
}

// Check if PDP is from customer service center(order on behalf of) and hide apple pay if so.
if (isOOBO && $applePayContainer) {
    $applePayContainer.remove();
    $('.attribute.quantity').removeClass('d-none');
    $('.add-to-cart-actions').removeClass('qty-hidden');
}
// Remove apple pay related functionality/element on other browsers
if (!window.ApplePaySession && $applePayContainer) {
    $applePayContainer.remove();
    if ($('.attribute.quantity').hasClass('d-none')) {
        $('.attribute.quantity').removeClass('d-none');
    }
    if ($('.add-to-cart-actions').hasClass('qty-hidden')) {
        $('.add-to-cart-actions').removeClass('qty-hidden');
    }
}

/**
 * parse HTML for bonus product
 * @param {string} html HTML string
 * @returns {Object} body and footer elements
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));
    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * reset quality Error message
 * @param {jQuery} $productContainer container reference
 */
function resetQuantityErrorMessage($productContainer) {
    $productContainer.find('.page-quantity-error').empty();
}

/**
 * show quantity error message
 * @param {Stringh} message error message
 * @param {jQuery} $productContainer container reference
 */
function showQualityErrorMessage(message, $productContainer) {
    $productContainer.find('.page-quantity-error').empty().html(utils.showErrorMessage(message));
}

/**
 * choose bonus product modal window
 * @param {Object} data response data
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * handle unchecked variations
 * @param {jQuery} $errorContainer Error container ID
 * @param {jQuery} $elementLabel Label element
 * @param {jQuery} displayId variation ID
 */
function unCheckedVariation($errorContainer, $elementLabel, displayId) {
    if (!$errorContainer.hasClass('show')) {
        $errorContainer.addClass('show');
    }
    if (displayId === 'size') {
        $('.size .variation__attr--name').addClass('custom-error');
    }

    if (!$elementLabel.hasClass('custom-error')) {
        $elementLabel.addClass('custom-error');
    }
}

/**
 * handle variations
 * @param {jQuery} displayId variation ID
 * @param {jQuery} $errorContainer Error container ID
 * @param {jQuery} $elementLabel Label element
 */
function handleVariations(displayId, $errorContainer, $elementLabel) {
    if ($('button.add-to-cart').is(':disabled')) {
        $('.variant-list').each(function () {
            // eslint-disable-next-line
            displayId = $(this).attr('data-display-id');
            if ($('.variant-' + displayId + '[aria-checked="true"]').length === 0) {
                // eslint-disable-next-line
                $errorContainer = $('.variant-error-' + displayId);
                // eslint-disable-next-line
                $elementLabel = $('.' + displayId);
                $errorContainer.removeClass('hide');
                unCheckedVariation($errorContainer, $elementLabel, displayId);
            }
        });
    }
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * Handle selectable non swatch attributes
 * @param {jQuery} $this - DOM element
 * @param {string} attrValue - Attribute Value
 */
// eslint-disable-next-line
function handleSelectableEachNonSwatchAttr($this, attrValue) {
    if (!attrValue.selectable) {
        // $this.attr('disabled', '');
        // $attrValue.attr('hidden', '');
        $this.addClass('disabled');
    }
    if (attrValue.selected) {
        $this.attr('aria-checked', 'true');
    } else {
        $this.attr('aria-checked', 'false');
    }
}

/**
 * One Size product identification
 *
 * @param {string} sizeVariation - to find out product is one size or not
*  @return {boolean} - boolean for one size product identification.
 */
function isOneSizeProduct(sizeVariation) {
    return sizeVariation.id.toLowerCase() === 'one size' || sizeVariation.id.toLowerCase() === 'onesize';
}

/**
 * Generates a string of image badges based on product data.
 *
 * @param {Object} product - The product object containing badge information.
 * @returns {string} - A comma-separated string of image badges.
 */
function generateImageBadges(product) {
    let imageBadges = '';

    if (product.badgeSkuLevelStatus.newBadge) {
        imageBadges += product.badgeSkuLevelStatus.newBadge;
        imageBadges += product.ImagebadgeSkuLevelStatus.imageBadge1 || product.ImagebadgeSkuLevelStatus.imageBadge2 ? ' , ' : '';
    }

    if (product.ImagebadgeSkuLevelStatus.imageBadge1) {
        imageBadges += product.ImagebadgeSkuLevelStatus.imageBadge1;
    } else if (product.ImagebadgeSkuLevelStatus.imageBadge2) {
        imageBadges += product.ImagebadgeSkuLevelStatus.imageBadge2;
    }

    return imageBadges;
}

/**
 * Generates a string of sale badges based on product data and site context.
 *
 * @param {Object} product - The product object containing badge information.
 * @returns {string} - A string of sale badges.
 */
function generateSaleBadges(product) {
    let saleBadges = '';
    let hasInStockValue = !product.badgeSkuLevelStatus.availabilityStatus && product.availability.inStockValue.length !== 0;
    let hasFinalSaleStatus = product.badgeSkuLevelStatus.finalSalestatus;

    if (utils.isTHSite()) {
        hasInStockValue = hasInStockValue && !product.isTeaserProduct;
        hasFinalSaleStatus = hasFinalSaleStatus && !product.isTeaserProduct;
    }

    if (hasFinalSaleStatus) {
        saleBadges += '<div class="custom-error product-detail__salebadges-text">Final Sale</div>';
    }

    if (hasInStockValue) {
        saleBadges += `<div class="product-detail__salebadges-text inventory-msg">${product.availability.inStockValue[0]} </div>`;
    }
    return saleBadges;
}

/**
 * Generates a string representing the pre-order status message and date.
 *
 * @param {Object} product - The product object containing pre-order information.
 * @returns {string} - A string containing the pre-order message and date, or an empty string if not a pre-order product.
 */
function generatePreOrderStatus(product) {
    let preOrderStatus = '';
    if (product.badgeSkuLevelStatus.preOrderStatus) {
        const responseMessage = product.badgeSkuLevelStatus.preOrderMessage;
        const responseMessageDate = product.badgeSkuLevelStatus.preOrderMessageDate;
        preOrderStatus += `<div class="pre-order"> <span>${responseMessage}</span> <span class="pre-order-date">${responseMessageDate}</span> </div>`;
    }
    return preOrderStatus;
}

/**
 * Generates a string of availability messages based on product data.
 *
 * @param {Object} product - The product object containing availability information.
 * @returns {string} - A string of availability messages.
 */
function generateAvailabilityMessages(product) {
    let availabilityValue = '';
    const isOneSize = isOneSizeProduct(product.variationAttributes[1].values[0]);

    if (product.availability.inStockValue.length === 0 && (product.readyToOrder || isOneSize)) {
        product.availability.messages.forEach(function (message) {
            if (product.availability.cartMessage.length) {
                availabilityValue += `<li><div class="${product.availability.cartMessage.length ? '' : 'page-error'}">${message}</div></li>`;
            }
        });
    }

    return availabilityValue;
}


/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var finalSale = '';
    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: generateAvailabilityMessages(response.product),
        resources: response.resources,
        preOrderStatus: generatePreOrderStatus(response.product),
        badges: generateImageBadges(response.product),
        saleBadges: generateSaleBadges(response.product),
        finalSale: finalSale
    });

    if (utils.isTHSite()) {
        if (response.product.isTeaserProduct) {
            $('.availability.product-availability').hide();
        }
    }
}

/**
 * Process the Non-Swatch label attributes
 * @param {jQuery} productSetContainer - DOM container for a given product in product set
 * @param {string} attrValue - Attribute Value
 * @param {Object} attr - Attribute
 * @param {string} nonSwatchLabel - Swatch label
 * @param {Object[]} $attrValue - Attribute coded value
 * @param {string} $variationAttribute - Attribute Value
 */
function handleNonSwatchLabelAttrs(productSetContainer, attrValue, attr, nonSwatchLabel, $attrValue, $variationAttribute) {
    var isOneSize = isOneSizeProduct(attrValue);
    var selectedSize = $('#sizes' + attr.attributeId + ' input[aria-checked="true"]').attr('data-attr-value');
    if (!attrValue.selectable) {
        // $attrValue.attr('disabled', '');
        $attrValue.addClass('disabled oos-variant').next('label').removeClass('size-enabled').addClass('size-disabled'); // size-disabled and size-disabled are for catchpoint scripts only and not to be leveraged for css styling
    }
    if ((attrValue.selected || isOneSize) && quantityHelper.isProductSetavailable()) {
        $(productSetContainer).find('h3.' + attr.id).html(
            `<span class="variation__attr--name d-inline mb-0" tabindex="0">${attr.displayName}</span>
            <span class="variation__attr--value d-inline mb-0" tabindex="0">${isOneSize ? attrValue.displayValue : attr.displayValue}</span>`
        );
        if (nonSwatchLabel !== '') {
            $(productSetContainer).find('.size-label').html(nonSwatchLabel);
        }
        $(productSetContainer).find($attrValue).attr('aria-checked', 'true');
        $(productSetContainer).find($variationAttribute).attr('aria-checked', 'true');
    } else if ((attrValue.selected || isOneSize) && !quantityHelper.isProductSetavailable()) {
        $('h3.' + attr.id).html(`
            <span class="variation__attr--name d-inline mb-0" tabindex="0">${attr.displayName}</span>
            <span class="variation__attr--value d-inline mb-0" tabindex="0">${isOneSize ? attrValue.displayValue : attr.displayValue}</span>`
        );
        if (nonSwatchLabel !== '') {
            $('.size-label').html(nonSwatchLabel);
        }
        $attrValue.attr('aria-checked', 'true');
        $variationAttribute.attr('aria-checked', 'true');
    } else if (!attrValue.selectable && selectedSize === attrValue.value) {
        $('h3.' + attr.id).html(`
            <span class="variation__attr--name d-inline mb-0" tabindex="0">${attr.displayName}</span>
            <span class="variation__attr--value d-inline mb-0" tabindex="0">${attrValue.displayValue}</span>`
        );
        $attrValue.attr('aria-checked', 'true');
        $variationAttribute.attr('aria-checked', 'true');
    } else {
        $attrValue.attr('aria-checked', 'false');
        $variationAttribute.attr('aria-checked', 'false');
    }
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {boolean} strikeThroughStatus - Having strikeThroughStatus true or false
 * @param {boolean} nonSwatchLabel - Non swatch label
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product in a product set
 * @param {string} productId - unique id of product in string
 */
// eslint-disable-next-line
function renderNonSwatchValues(attr, strikeThroughStatus, nonSwatchLabel, $productContainer, productId, attrId, isTeaserProduct) {
    var nonSwatchValues = document.createDocumentFragment();
    var variationSelected = false;
    // Locate the variant selector container
    var variantSelector = $(
        `.variation-spacing-${attr.id} .variant-selector-container.size-container-${productId} div.variant-list`,
        $productContainer
    );
    var selectorLabels = variantSelector.find('label');
    // Get the currently selected size
    var selectedSize = $(`#sizes${attr.attributeId} input[aria-checked="true"]`).attr('data-attr-value');
    // Iterate over the attribute values to create input and label elements securely
    var sizeSelected;
    attr.values.forEach(function (attrValue, index) {
        sizeSelected = false;
        if (!(!strikeThroughStatus && !attrValue.selectable) || isTeaserProduct) {
            // eslint-disable-next-line
            var disableState = !attrValue.selectable;
            if (attrValue.selected || (attrValue.unavailableColors && selectedSize === attrValue.value)) {
                variationSelected = true;
                sizeSelected = true;
            }
            // eslint-disable-next-line
            // Create input element
            var inputElement = document.createElement('input');
            inputElement.type = 'radio';
            inputElement.className = `d-none ds-radio-size variant-item variant-${attr.id}`;
            if (disableState) {
                inputElement.className += ' oos-variant'; // Add "out of stock" class
                var inputLabelElement = inputElement.nextElementSibling; // Get the next sibling (the <label>)

                if (inputLabelElement && inputLabelElement.tagName.toLowerCase() === 'label') {
                    inputLabelElement.className += ' size-disabled';  // Add "size-disabled" class to the label
                }
            }
            inputElement.id = `${productId}_${attr.id}item${index}`;
            inputElement.setAttribute('aria-checked', sizeSelected);
            inputElement.setAttribute('data-attr-value', attrValue.value);
            inputElement.setAttribute('data-url', attrValue.url);
            inputElement.setAttribute('data-display-id', attr.id);
            if (disableState) {
                inputElement.disabled = true; // Disable if not selectable
            }

            // Create label element
            var labelElement = document.createElement('label');
            labelElement.htmlFor = inputElement.id;
            labelElement.setAttribute('aria-label', attrValue.displayValue);
            labelElement.setAttribute('aria-checked', sizeSelected);
            labelElement.setAttribute('role', 'radio');
            labelElement.textContent = attrValue.displayValue; // Assign text safely
            if (attrValue.selectable) {
                labelElement.tabIndex = 0;
            } else {
                labelElement.tabIndex = -1;
            }

            // Append input and label to the DocumentFragment
            nonSwatchValues.appendChild(inputElement);
            nonSwatchValues.appendChild(labelElement);
        }
    });
    // Update the DOM securely
    variantSelector.toggleClass('selected', variationSelected);
    variantSelector.empty().append(nonSwatchValues);
    if (attrId !== attr.id && $(selectorLabels[1]).hasClass('modal-error-border')) {
        selectorLabels.each(function () {
            $(this).addClass('modal-error-border');
        });
    }
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 * @param {boolean} strikeThroughStatus - Having strikeThroughStatus true or false
 * @param {boolean} nonSwatchLabel - Non swatch label
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product in a product set
 * @param {string} productId - unique id of product in string
 */
// eslint-disable-next-line
function processNonSwatchValues(attr, strikeThroughStatus, nonSwatchLabel, $productContainer, productId, attrId,  isTeaserProduct) {
    renderNonSwatchValues(attr, strikeThroughStatus, nonSwatchLabel, $productContainer, productId, attrId, isTeaserProduct);
    attr.values.forEach(function (attrValue, index) {
        var $attrValue = $(`#${productId}_${attr.id}item${index}`);
        var $variationAttribute = $(`#variation_element_${productId}_${attr.id}item${index}`);
        const attributeId = `${productId}_${attr.id}item${index}`;
        const isSelectableLabel = document.querySelectorAll("label[for='" + attributeId + "']");   //eslint-disable-line
        if (quantityHelper.isProductSetavailable()) {
            $attrValue = $productContainer.find(`#${attributeId}`);
        }
        if (!(!strikeThroughStatus && !attrValue.selectable) || isTeaserProduct) {
            $attrValue.show();
            $attrValue.attr('data-url', attrValue.url).removeAttr('disabled');
            handleNonSwatchLabelAttrs($productContainer, attrValue, attr, nonSwatchLabel, $attrValue, $variationAttribute);
        } else {
            $attrValue.hide();
        }
        if (!attrValue.selectable && !isTeaserProduct) {
            // $attrValue.attr('disabled', '');
            $attrValue.addClass('disabled oos-variant').next('label').removeClass('size-enabled').addClass('size-disabled'); // size-disabled and size-disabled are for catchpoint scripts only and not to be leveraged for css styling

            if (!strikeThroughStatus && !isTeaserProduct) {
                $(isSelectableLabel).css('display', 'none');
            }
        } else {
            $attrValue.removeClass('disabled oos-variant').next('label').removeClass('size-disabled').addClass('size-enabled'); // size-disabled and size-disabled are for catchpoint scripts only and not to be leveraged for css styling
            $(isSelectableLabel).css('display', 'flex');
        }
    });
}


/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {boolean} strikeThroughStatus - Having strikeThroughStatus true or false
 * @param {jQuery} productSetContainer - DOM element for a given product in a product set
 * @param {string} productId - unique id of product in string
 */
// eslint-disable-next-line
function updateAttrs(attrs, strikeThroughStatus, $productContainer, productId, attrId, isTeaserProduct = false) {
    var isOneSize = isOneSizeProduct(attrs[1].values[0]);
    var nonSwatchLabel = '';

    attrs.forEach(function (attr) {
        if (!attr.swatchable && attr.displayValue !== '') {
            nonSwatchLabel += attr.displayValue + ' X ';
        } else {
            $productContainer.find(`h3.${attr.attributeId}`).html(`<span class="variation__attr--name">${attr.displayName}</span>`);
        }
    });

    if (nonSwatchLabel !== '') {
        nonSwatchLabel = nonSwatchLabel.substring(0, nonSwatchLabel.length - 3);
    } else {
        // eslint-disable-next-line no-lonely-if
        if (isOneSize) {
            $('.size-label', $productContainer).html(attrs[1].values[0].displayValue);
        } else {
            var sizeLabel = $('input.qbb-size-label-text', $productContainer).attr('value');
            var sanitizedText = $('<div>').text(sizeLabel).html();
            $('.size-label', $productContainer).html(sanitizedText);
        }
    }

    attrs.forEach(function (attr) {
        if (attr.swatchable) {
            variationHelper.processSwatchValues(attr, strikeThroughStatus, $productContainer, productId, attrId, isTeaserProduct);
        } else {
            processNonSwatchValues(attr, strikeThroughStatus, nonSwatchLabel, $productContainer, productId, attrId, isTeaserProduct);
        }
    });
}

/**
 *
 Update Product URL for PDP
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} injectUrl - URL which is injected to element which has productSetName href attribute
 */
function updateProductSetUrl($productContainer, injectUrl) {
    $productContainer.find('.productSetName').attr('href', injectUrl);
}


/**
 * Update quick buy bar container
 *
 * @param {Object} data - Response object
 * @param {jQuery} $productContainer - DOM element for a given product.
 * @param {string} pid - product ID
 * @param {string} attrId - attribute ID
 */
function updateQuickBuy(data, $productContainer, pid, attrId) {
    var isOneSize = isOneSizeProduct(data.product.variationAttributes[1].values[0]);
    var buttonHtmlQbbM = 'Add to Bag';
    var buttonHtmlSelectSize = 'Select a Size';
    var isSizeSelected;
    var variantItemAria = $('.variant-item[aria-checked="true"]');
    var cartActionsContainer = $('.product-detail__attributes .stack-divs');
    if ($('button.sticky-add-to-cart').length) {
        $('button.sticky-add-to-cart').removeClass('disabled');
    }
    isSizeSelected = variantItemAria.length === data.product.variationAttributes.length - 1
        ? variantItemAria.hasClass('disabled')
        : false;
    var oosButton = 'Out of Stock';
    var currentDisplayPrice = ` - ${data.product.price.type === 'range' ? data.product.price.salesDisplayRange : data.product.price.salesDisplayPrice}`;
    $('button.add-to-cart').data('defaultdisplayprice', currentDisplayPrice);
    var buttonSalesPrice = data.product.isAddToBagPrice ? ' - ' + data.product.price.salesDisplayPrice : '';
    if (data.product.badgeSkuLevelStatus.preOrderStatus) {
        buttonHtmlQbbM = data.product.badgeSkuLevelStatus.preOrderBadge;
    }

    if (data.product.variationAttributes) {
        updateAttrs(data.product.variationAttributes, data.product.strikeThroughStatus, $productContainer, pid, attrId);
    }
    if (!data.product.readyToOrder && !isOneSize) {
        if (quantityHelper.isProductSetavailable()) {
            $productContainer.find('button.add-to-cart').attr('data-readytoorder', false);
            $('button.sticky-add-to-cart').attr('data-readytoorder', false);
            if ($applePayButton.length) {
                $('.applepay-container').attr('data-readytoorder', false);
            }
        } else {
            $('.add-to-cart, button.sticky-add-to-cart').attr('data-readytoorder', false);
            if ($applePayButton.length) {
                $('.applepay-container').attr('data-readytoorder', false);
            }
        }
        if (data.product.orderable) {
            if (isSizeSelected && data.product.available) {
                $('button.add-to-cart').html(oosButton).prop('disabled', true);
                $('button.sticky-add-to-cart').html(oosButton).addClass('disabled').attr('data-readytoorder', false);
                if ($applePayButton.length) {
                    $('.applepay-container').attr('data-readytoorder', false);
                }
                cartActionsContainer.addClass('qv-footer-oos');
            } else {
                $('button.add-to-cart, button.sticky-add-to-cart').html(buttonHtmlSelectSize);
                cartActionsContainer.removeClass('qv-footer-oos');
            }
        } else if (isSizeSelected && !data.product.available) {
            $('button.add-to-cart').html(oosButton).prop('disabled', true);
            $('button.sticky-add-to-cart').html(oosButton).addClass('disabled').attr('data-readytoorder', false);
            if ($applePayButton.length) {
                $('.applepay-container').attr('data-readytoorder', false);
            }
            cartActionsContainer.addClass('qv-footer-oos');
        } else if ($('.variant-item[aria-checked="true"]').length !== data.product.variationAttributes.length - 1) {
            $('button.add-to-cart, button.sticky-add-to-cart').html(buttonHtmlSelectSize);
            cartActionsContainer.removeClass('qv-footer-oos');
        } else {
            $('button.add-to-cart, button.sticky-add-to-cart').html(buttonHtmlQbbM);
            cartActionsContainer.removeClass('qv-footer-oos');
        }
    } else {
        if (quantityHelper.isProductSetavailable()) {
            $productContainer.find('button.add-to-cart').attr('data-readytoorder', true);
            if ($applePayButton.length) {
                $('.applepay-container').attr('data-readytoorder', true);
            }
            $productContainer.find('button.add-to-cart').html(buttonHtmlQbbM + buttonSalesPrice);
            cartActionsContainer.removeClass('qv-footer-oos');
        } else if ($('.variant-item[aria-checked="true"]').hasClass('disabled')) {
            $('button.add-to-cart').html(oosButton).prop('disabled', true);
            $('button.sticky-add-to-cart').html(oosButton).addClass('disabled').attr('data-readytoorder', false);
            if ($applePayButton.length) {
                $('.applepay-container').attr('data-readytoorder', false);
            }
            cartActionsContainer.addClass('qv-footer-oos');
        } else {
            $('button.add-to-cart, button.sticky-add-to-cart').attr('data-readytoorder', true);
            if ($applePayButton.length) {
                $('.applepay-container').attr('data-readytoorder', true);
            }
            $('button.add-to-cart, button.sticky-add-to-cart').html(buttonHtmlQbbM + buttonSalesPrice);
            cartActionsContainer.removeClass('qv-footer-oos');
        }

        if (data.product.price.salesDisplayPrice === null) {
            $('button.add-to-cart, button.sticky-add-to-cart').attr('data-readytoorder', true);
            if ($applePayButton.length) {
                $('.applepay-container').attr('data-readytoorder', true);
            }
        }
    }
}

/**
 * Validate the mandatory fields and show/remove error message
 * @param {string} attrId - event trigger from
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function attributeValidation(attrId, $productContainer) {
    var displayId = attrId;
    var $errorContainer = $(`.variant-error-${displayId}:not(.hide)`);
    if (quantityHelper.isProductSetavailable()) {
        $errorContainer = $productContainer.find('.variant-error-' + displayId);
    }
    var $elementLabel = $productContainer.find('.' + displayId);
    if (attrId === 'addToCart') {
        handleVariations(displayId, $errorContainer, $elementLabel);
    } else {
        $errorContainer.removeClass('show');
        if (!$errorContainer.hasClass('hide')) {
            $errorContainer.addClass('hide');
        }
        $productContainer.find('.size .variation__attr--name').removeClass('custom-error');
        if ($elementLabel.hasClass('custom-error')) {
            $elementLabel.removeClass('custom-error');
        }
    }
}

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 *
function to handle previous error response from server
 * @param {string} attribute_id -
 * @param {jQuery} $productContainer - DOM element for current product
 *
 */
function handlePreviousErrorResponse(attribute_id, $productContainer) {
    if (attribute_id === 'colorCode') {
        $productContainer.find('span.variation__attr--name').removeClass('modal-error-color');
        $productContainer.find('input[type="radio"].ds-radio-size+label').removeClass('modal-error-border');
        $productContainer.find('.variant-error').addClass('hide');
    } else {
        $productContainer.find('.' + attribute_id + ' span.variation__attr--name').removeClass('modal-error-color');
        $productContainer.find('input[type="radio"].ds-radio-size.variant-' + attribute_id + ' + label').removeClass('modal-error-border');
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 * @param {string} productId - unique id of product in string
 */
// eslint-disable-next-line
function handleVariantResponse(response, $productContainer, productId, attrId) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;

    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, response.product.strikeThroughStatus, $productContainer, productId, response.product.isTeaserProduct);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);
            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.product-promotions').empty().html(response.product.promotionsHtml);
    if (response.product.showShippingPromotion) {
        var shippingPromoList = '';
        response.product.shippingPromotion.forEach((elem) => {
            if (elem.calloutMsg !== '') {
                shippingPromoList += '<li class="list__description"><span class="list__description--shipping">' + elem.calloutMsg + '</span><span class="list__description--seperator">,</span> </li>';
            }
        });
        $productContainer.find('.shipping-promotions').empty().html('<ul class="promotion__list promotion__list--shipping">' + shippingPromoList + '</ul>');
    } else {
        $productContainer.find('.shipping-promotions').empty();
    }

    // Update loyalty message
    if (response.product.loyaltyHtml) {
        $productContainer.find('.loyaltyPoint').empty().html(response.product.loyaltyHtml);
    }

    // Update antavo points
    if (response.product.antavoPoints) {
        $productContainer.find('.antavo-points').empty().html(response.product.antavoPoints);
    }

    // Update antavo multiplier
    $productContainer.find('.wrapper-antavo-multiflier').empty();
    if (response.product.antavoPointsMultiplier > 1) {
        let $multiplierHtml = `<span class="antavo-multiflier">${response.product.antavoPointsMultiplier}X</span>`;
        $productContainer.find('.wrapper-antavo-multiflier').append($multiplierHtml);
    }

    // update prices
    $productContainer.find('.product-detail__prices').empty().html(response.product.price.html);
    // Clone the first price element and update the sticky add-to-cart container
    let $stickyatbPrice = $('.buy-box__price-and-promotion .price.ds-product-price').first().clone();
    $('.sticky-add-to-cart-container .sticky-prod-price').empty().html($stickyatbPrice);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').removeAttr('disabled');
    }
    // price null check on AddToBag CTA
    utils.disableButton($('.add-to-cart-actions button.add-to-cart'), response.product.price.salesDisplayPrice);
    // price null check on AddToBag CTA QBB
    // utils.disableButton($('.cart__button--desktop button.add-to-cart'), response.product.price.salesDisplayPrice);

    // Update attributes
    $productContainer.find('.main-attributes').empty().html(getAttributesHtml(response.product.attributes));

    // Hide 'UPTO' text when a size is selected
    if (response.product.price.type === 'range') {
        $productContainer.find('.text-more span').show();
    } else {
        $productContainer.find('.text-more span').hide();
    }
}

/**
 * Toggles the visibility of an element based on pre-order status.
 *
 * @param {Object} product - The product object containing pre-order information.
 * @param {jQuery} $element - The jQuery element to show or hide.
 */
function togglePreOrderVisibility(product, $element) {
    if (product.badgeSkuLevelStatus.preOrderStatus) {
        $element.addClass('d-none');
    } else {
        $element.removeClass('d-none');
    }
}

/**
 * Toggles feature for after pay messaging for pre-orders.
 *
 * @param {Object} product - The product object containing pre-order information.
 * @param {jQuery} $targerElement - The jQuery element to show or hide.
 */
function togglePreOrderAfterpayVisibility(product, $targerElement) {
    $targerElement.removeClass('hide-afterpay-messaging');
    if (product.badgeSkuLevelStatus.preOrderStatus) {
        $targerElement.addClass('hide-afterpay-messaging');
    } else {
        $targerElement.removeClass('hide-afterpay-messaging');
    }
}

/**
 * Toggles feature for after pay messaging for pre-orders.
 *
 * @param {Object} product - The product object containing pre-order information.
 * @param {jQuery} $wrapperElement - The jQuery element to show or hide.
 */
function togglePreOrderAfterpayInmodal(product, $wrapperElement) {
    $wrapperElement.removeClass('hide-afterpay-inmodal');
    if (product.badgeSkuLevelStatus.preOrderStatus) {
        $wrapperElement.addClass('hide-afterpay-inmodal');
    } else {
        $wrapperElement.removeClass('hide-afterpay-inmodal');
    }
}

/**
 * Retrieves the product ID from the provided container.
 *
 * @param {jQuery} $productContainer - The jQuery object representing the product container.
 * @returns {string} - The product ID.
 */
function getProductId($productContainer) {
    return $productContainer.attr('data-pid') || $('.product-detail.product-wrapper').attr('data-pid');
}

/**
 * Sets the product ID data attribute on the "Add to Cart" button.
 *
 * @param {Object} product - The product object containing ID and oneSizeSKUID.
 * @param {jQuery} $productContainer - The jQuery object representing the product container.
 */
function setAddToCartButtonProductId(product, $productContainer) {
    const isOneSize = isOneSizeProduct(product.variationAttributes[1].values[0]);
    const productId = !isOneSize && !product.oneSizeSKUID ? product.id : product.oneSizeSKUID;

    if (quantityHelper.isProductSetavailable()) {
        $productContainer.find('.add-to-cart').attr('data-cur-pid', productId);
    } else {
        $('.add-to-cart').attr('data-cur-pid', productId);
    }

    $('.add-to-cart').attr('data-category-id', product.productCgId);
}

/**
 * Updating SKU on apple pay cta on variant change
 * @param {Object} product - product
 */
function setApplePayProductID(product) {
    const isOneSize = isOneSizeProduct(product.variationAttributes[1].values[0]);
    const productId = !isOneSize && !product.oneSizeSKUID ? product.id : product.oneSizeSKUID;
    $('.dw-apple-pay-button').attr('sku', productId);
}


/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} attrId - event trigger from
 * @param {string} selectedAttrValue - attr value
 * @param {boolean} isViewAllColorPanel - boolean to indicate color panel state
 */
function attributeSelect(selectedValueUrl, $productContainer, attrId, selectedAttrValue, isViewAllColorPanel) {
    if (selectedValueUrl) {
        $.ajax({
            url: selectedValueUrl,
            data: { attrId: attrId, isPDP: true },
            method: 'GET',
            success: function (data) {
                sessionStorage.removeItem('openQVSigntoBuy');
                if (data.product.isMembersOnly && !isCustomerAuthenticated) {
                    if (data.queryString) {
                        var selectedProductUrl = data.product.selectedProductUrl || data.pdpurl || window.location.href;
                        sessionStorage.setItem('openQVSigntoBuy', selectedProductUrl);
                    }
                    $loginPromptButton.removeClass('d-none');
                    $addToCartButton.addClass('d-none');
                    $stickyAddToCartButton.addClass('d-none');
                    $('#sizebay-container').attr('data-member-only', true);
                } else if (data.product.isMembersOnly && isCustomerAuthenticated) {
                    $loginPromptButton.addClass('d-none');
                    $addToCartButton.removeClass('d-none');
                    $stickyAddToCartButton.removeClass('d-none');
                    $('#sizebay-container').attr('data-member-only', false);
                } else {
                    $loginPromptButton.addClass('d-none');
                    $addToCartButton.removeClass('d-none');
                    $stickyAddToCartButton.removeClass('d-none');
                    $('#sizebay-container').attr('data-member-only', false);
                }
                $('.product-detail__page_level_error').addClass('d-none');
                resetQuantityErrorMessage($productContainer);
                togglePreOrderVisibility(data.product, $('.hide-afterpay-preorder'));
                togglePreOrderAfterpayVisibility(data.product, $('.klarna-afterpay-messaging'));
                togglePreOrderAfterpayInmodal(data.product, $('.product-detail'));
                setAddToCartButtonProductId(data.product, $productContainer);
                setApplePayProductID(data.product);

                var pid = getProductId($productContainer);
                var $defaultColor = $('div.variant-selector-container ul li').find('input[aria-checked="true"]').attr('data-attr-value');
                handleVariantResponse(data, $productContainer, pid, attrId);
                handlePreviousErrorResponse(attrId, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                quantityHelper.updateQuantities(data.product, $productContainer, pid);
                attributeValidation(attrId, $productContainer);
                updateQuickBuy(data, $productContainer, pid, attrId);
                updateProductSetUrl($productContainer, data.product.selectedProductUrl);

                // trigger after event
                $('body').trigger('product:afterAttributeSelect', { data: data, container: $productContainer, attrId: attrId, selectedAttrValue: selectedAttrValue });
                if (window.dw && window.dw.applepay && window.ApplePaySession) {
                    document.cookie = 'dwapupreq=' + Date.now() + '; path=/';
                }
                // analytics
                if (attrId && (attrId === 'colorCode' || attrId === 'colorcode')) {
                    if ($defaultColor && selectedAttrValue && (selectedAttrValue.toString().toLowerCase() !== $defaultColor.toString().toLowerCase())) {
                        tealiumEnable.getAnalyticsData('selectColorOrSizeEvent', data, attrId, isViewAllColorPanel);
                    }
                    $('.sizebay-view-event').attr('data-sizebay-view', JSON.stringify(data.product.sizebayObject));
                    window.history.replaceState(null, '', data.product.pdpurl);
                } else {
                    tealiumEnable.getAnalyticsData('selectColorOrSizeEvent', data, attrId, isViewAllColorPanel);
                }
                var colorCodes = $('.variant-list.variant-list--colorCode li input');
                utils.oosColorSwatches(data.product.variationAttributes, colorCodes);

                // If apple pay eligible and variant is in stock, show apple pay CTA. If not, hide it.
                if ($applePayContainer && data.product.available && $applePayContainer.hasClass('d-none')) {
                    $applePayContainer.removeClass('d-none');
                } else if ($applePayContainer && !data.product.available && !$applePayContainer.hasClass('d-none')) {
                    $applePayContainer.addClass('d-none');
                }

                $.spinner().stop();
            },
            error: function () {
                $('.product-detail__page_level_error').removeClass('d-none');
                $.spinner().stop();
            }
        });
    }
}


/**
 * Handles ajax errors when adding an item to the cart
 * @param {Object} data - response from ajax call
 * @param {jQuery} $productContainer - DOM element for current product
 */
function onAddToCartError(data, $productContainer) {
    showQualityErrorMessage(data.responseJSON.message, $productContainer);
    tealiumEnable.getAnalyticsData('serverError', data.responseJSON.errorCode);
}

/**
 * Handle post actions after product is added to cart
 * @param {Objecdt} response Ajax Response
 * @param {string} pid - product ID
 */
function handlePostCartAdd(response, pid) {
    $('.minicart').trigger('count:update', [response, pid]);
    utils.updateCartCount(response.quantityTotal);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast

    // FIXME : check the usecase when these message is shown ?
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        productHelper.chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
            + response.message
            + '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

    /**
     * Add to cart analytics
     * @param {Object} data - data layer information
     * @param {Object} form - form data
     * @param {jQuery} $productContainer - DOM element for current product
     * @param {boolean} sizebay - true if added to cart from size bay
     */
function addToCartAnalytics(data, form, $productContainer, sizebay) {
        // tealium event
    var setId = $('.product-set-detail', $productContainer).data('pid');
    var cartAddMethod;
    if ($('.add-to-cart', $productContainer).parent().parent().hasClass('productSet--attribute__addtocart')) {
        cartAddMethod = 'bundle';
    }

        // offsetX provides the offset in the X coordinate of the mouse pointer between that event and the padding edge of the target node. Same goes with offsetY
        // In case of jquery .click(), the values will be 0.
    if (e.offsetX === 0 && e.offsetY === 0) {
        cartAddMethod = 'pdp_fitfinder';
    }

    if (sizebay) {
        cartAddMethod = 'SizeBay';
    }

    var eventName = 'cart_add,cart_open';
    tealiumEnable.getAnalyticsData('addToCartEvent', data, form, cartAddMethod, setId, eventName);
}

 /**
 * Add to cart analytics
 * @param {string} productID - product ID
 * @param {string[]} variationErrorAnalytics - add to cart related errors
 */
function addToCartErrorAnalytics(productID, variationErrorAnalytics) {
    // tealium event
    var eventName = 'product_variant_error';
    tealiumEnable.getAnalyticsData('addToCartErrorEvent', productID, eventName, variationErrorAnalytics);
}

/**
 * Handle anchoring back to size when there is issue/error for PDP ATB
 */
function anchorBackToPdpSize() {
    var $stickyFlag = $('.stickyatb-flag');
    var $globalNavHeader = $('.js-globalnav-header .ds-navbar');
    var $variationSpacingSize = $('.product-detail .variation-spacing-size');

    // Check if stickyatb-flag exists and the data-eventfired attribute is true
    if ($stickyFlag.length && $stickyFlag.attr('data-eventfired') === 'true') {
        var anchorToSize = $variationSpacingSize.offset().top - $globalNavHeader.outerHeight();
        $('html, body').animate({
            scrollTop: anchorToSize
        }, 50);
        $stickyFlag.attr('data-eventfired', false);
    }
}

/**
 * Handles add to cart logic
 * @param {string} addToCartUrl - url to use when adding to cart
 * @param {Object} form - form object used to make ajax call
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} pid - product id
 * @param {boolean} sizebay - true if prdocut added from size bay
 */
function addProductToCart(addToCartUrl, form, $productContainer, pid, sizebay) {
    $.ajax({
        url: addToCartUrl,
        method: 'POST',
        data: form,
        success: (data) => {
            if (data.error) {
                showQualityErrorMessage(data.message, $productContainer);
                anchorBackToPdpSize();
            } else {
                verifyOOSIfRequired(data, function (updatedData) {
                    data = updatedData; // eslint-disable-line
                    resetQuantityErrorMessage($productContainer);
                    if (pid) {
                        handlePostCartAdd(data, pid);
                    } else {
                        handlePostCartAdd(data);
                    }

                    addToCartAnalytics(data, form, $productContainer, sizebay);
                    $('body').trigger('product:afterAddToCart', data);
                    if ($('.stickyatb-flag').length && $('.stickyatb-flag').attr('data-eventfired') === 'true') {
                        $('[data-eventfired="true"]').attr('data-eventfired', false);
                    }
                    window.cartItemsObject = data.cartItemObject;
                });
            }
            $.spinner().stop();
        },
        error: (data) => {
            if (data.responseJSON.csrfError) {
                var authenticatedCust = data.responseJSON.authenticatedCustomer;
                isCustomerAuthenticated = authenticatedCust;
                if (isProductMembersOnly && !authenticatedCust) {
                    $loginPromptButton.removeClass('d-none');
                    $addToCartButton.addClass('d-none');
                    $stickyAddToCartButton.addClass('d-none');
                } else if (isProductMembersOnly && authenticatedCust) {
                    $loginPromptButton.addClass('d-none');
                    $addToCartButton.removeClass('d-none');
                    $stickyAddToCartButton.removeClass('d-none');
                } else {
                    $loginPromptButton.addClass('d-none');
                    $addToCartButton.removeClass('d-none');
                    $stickyAddToCartButton.removeClass('d-none');
                }
                utils.handleCsrfToken(() => onAddToCartError(data, $productContainer));
            } else {
                onAddToCartError(data, $productContainer);
            }
            anchorBackToPdpSize();
            $.spinner().stop();
        }
    });
}
export default {
    attributeSelect,
    attributeValidation,
    chooseBonusProducts,
    addProductToCart,
    addToCartErrorAnalytics
};
